
import React from 'react';
import { Marker } from '@react-google-maps/api';
import { Exhibit } from '@/data';

interface ExhibitMarkerProps {
  exhibit: Exhibit;
  onClick: () => void;
}

const ExhibitMarker = ({ exhibit, onClick }: ExhibitMarkerProps) => {
  return (
    <Marker
      key={exhibit.id}
      position={{
        lat: exhibit.location.latitude!,
        lng: exhibit.location.longitude!
      }}
      onClick={onClick}
      icon={{
        url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24' fill='%23f7704380' stroke='%23f77043' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z'%3E%3C/path%3E%3Ccircle cx='12' cy='10' r='3'%3E%3C/circle%3E%3C/svg%3E",
        scaledSize: window.google && window.google.maps ? new window.google.maps.Size(40, 40) : null,
        origin: window.google && window.google.maps ? new window.google.maps.Point(0, 0) : null,
        anchor: window.google && window.google.maps ? new window.google.maps.Point(15, 30) : null
      }}
    />
  );
};

export default ExhibitMarker;
